(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Resources.IUL",
            {
                url: "/IUL",
                component: "iul",
                PageTitle: "IUL",
                requiredPermissions: "IulComplete:View",
                resolve: {
                    states: ["states", function (states) {
                        return states;
                    }]
                }
            });
        }
    ]);

    app.component("iul",
    {
        templateUrl: "App/Resources/IUL/iul.html",
        controller: iulCtrl,
        bindings: {
            states: "<"
        }
    });

    iulCtrl.$inject = ["eligibilityFormDialog", "surveys", "eligibilityFormApi", "permissionService", "amplitudeService"];

    function iulCtrl(eligibilityFormDialog, surveys, eligibilityFormApi, permissionService, amplitudeService) {
        var $ctrl = this;

        $ctrl.logAmplitude = function (propertyName) {
            return amplitudeService.logClickEvent(propertyName);
        };

        surveys.then(function (s) {
            eligibilityFormApi.isEnrolled(s.iulCompleteId).then(function (response) {
                $ctrl.submitted = response;
            });
        });
        
        /*  Open the Enrollment Form  */
        $ctrl.openDialog = function (event) {
            surveys.then(function (s) {
                eligibilityFormDialog.open(event, s.iulCompleteId).then(function(obj) {
                    ng.extend($ctrl, obj);
                });
            });
        }

        $ctrl.loadResources = function () {
            //TODO: if ever has assets, add wistia get function here          
        }

        if (permissionService.hasOnePermission("IulComplete:Access")) {
            $ctrl.loadResources();
        } 
    }
})(window.app, window.angular); // jshint ignore:line